import gsap, { Power0 } from 'gsap';
import SplitText from '../../../lib/SplitToText';

export default function createFirstTimeline({
  mainElementTriggerRef,
  rightColumnRef,
  leftTextColumnRef,
  setIsFirstTimelineCompleted,
}) {
  let tl = gsap
    .timeline({
      scrollTrigger: {
        trigger: mainElementTriggerRef.current,
        start: 'top center',
        once: true,
      },
      id: `jbt-in-new`,
      onComplete: () => setIsFirstTimelineCompleted(true),
    })
    // .add(scrollUpList(rightColumnRef))
    .add(fadeUp(leftTextColumnRef, rightColumnRef), '<15%');

  return tl;
}

/*function scrollUpList(rightColumnRef) {
  let tl = gsap.timeline({ id: 'scrollUpListHoveras' });

  return tl
    .from(rightColumnRef.current, {
      opacity: 0,
      duration: 1,
      ease: Power2.easeIn,
    })
    .from(
      rightColumnRef.current.getElementsByClassName('border-item'),
      {
        duration: 0.5,
        ease: Power2.easeIn,
        scaleX: 0,
        transformOrigin: `100%`,
      },
      '<85%',
    )
    .from(
      rightColumnRef.current,
      {
        y: 300,
        transformOrigin: 'center',
        duration: 1.5,
        ease: Power2.easeIn,
      },
      '<70%',
    );
  // .to(
  //   rightColumnRef.current,
  //   {
  //     ease: Power2.easeInOut,
  //     scrollTo: rightColumnRef.current.scrollHeight,
  //     duration: 1.5,
  //   },
  //   '<75%',
  // );
}*/

function fadeUp(title, list) {
  let tl = gsap.timeline({
    id: 'fadeUpHoverNumberedList',
    onComplete: function (animationInstance) {
      splitTitle.revert();
    },
  });

  let splitTitle = new SplitText(title.current, {
    type: 'lines',
  });

  return tl
    .from(title.current, {
      opacity: 0,
      duration: 0.5,
      ease: Power0.easeIn,
    })
    .from(list.current, {
      opacity: 0,
      duration: 1,
      ease: Power0.easeIn,
    })
    .fromTo(
      splitTitle.lines,
      {
        stagger: {
          amount: 2,
          from: 'end',
        },
        lineHeight: 1.7,
        ease: Power0.easeIn,
      },
      {
        lineHeight: 1.2,
      },
      '<',
    );
}
